import { useEffect, useState } from "react";
import { RotateCcw } from "lucide-react";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";
import { StatusBadge } from "@/components/admin/AdminLayout";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const STATUSES = ["Requested", "Approved", "Rejected", "Awaiting Return", "Returned", "Refund Processing", "Refunded", "Closed"];

export default function Returns() {
  const [returns, setReturns] = useState([]);
  const load = () => api.get("/admin/returns").then((r) => setReturns(r.data));
  useEffect(() => { load(); }, []);

  const setStatus = async (id, status) => {
    try { await api.put(`/admin/returns/${id}/status`, { status }); toast.success("Return updated"); load(); }
    catch (e) { toast.error(apiErr(e)); }
  };

  return (
    <div className="space-y-5">
      <div><h1 className="font-display text-2xl font-bold tracking-tight">Returns & Refunds</h1><p className="text-sm text-zinc-500">{returns.length} return requests</p></div>

      {returns.length === 0 ? (
        <div className="bg-white border border-zinc-200 rounded-xl p-16 text-center text-zinc-400">
          <RotateCcw size={40} className="mx-auto mb-3" /><p className="text-sm">No return requests yet.</p>
        </div>
      ) : (
        <div className="bg-white border border-zinc-200 rounded-xl overflow-hidden">
          <table className="w-full text-sm">
            <thead><tr className="text-left text-xs text-zinc-500 bg-zinc-50 border-b border-zinc-200">
              <th className="p-3 font-medium">Order</th><th className="p-3 font-medium">Customer</th>
              <th className="p-3 font-medium">Reason</th><th className="p-3 font-medium">Date</th>
              <th className="p-3 font-medium">Status</th><th className="p-3 font-medium">Update</th>
            </tr></thead>
            <tbody>
              {returns.map((r) => (
                <tr key={r.id} className="border-b border-zinc-50">
                  <td className="p-3 font-mono text-xs">{r.order_number}</td>
                  <td className="p-3 text-zinc-600">{r.email}</td>
                  <td className="p-3 text-zinc-500 max-w-[200px] line-clamp-1">{r.reason}</td>
                  <td className="p-3 text-xs text-zinc-400">{new Date(r.created_at).toLocaleDateString()}</td>
                  <td className="p-3"><StatusBadge status={r.status} /></td>
                  <td className="p-3">
                    <Select value={r.status} onValueChange={(v) => setStatus(r.id, v)}>
                      <SelectTrigger className="w-40 h-8 text-xs" data-testid={`return-status-${r.id}`}><SelectValue /></SelectTrigger>
                      <SelectContent>{STATUSES.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent>
                    </Select>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
